const CODE = {
  MAINTENANCE: 99,
}

export default CODE
